import { Box } from '@factorialco/deprecated-design-system'

import { JobCatalogPerson } from 'modules/job_catalog/pages/NodePage/PeoplePage/useJobCatalogPeople'

import { JobCatalogGenderChart } from './GenderChart'
import { useJobCatalogGenderData } from './useJobCatalogGenderData'

interface JobCatalogPeopleChartsProps {
  people: JobCatalogPerson[]
  groupedBy: string
  isLevel: boolean
}

export const JobCatalogPeopleCharts = ({
  people,
  groupedBy,
  isLevel,
}: JobCatalogPeopleChartsProps) => {
  const { data, keys, count, malePercentage, femalePercentage, notDeclaredPercentage } =
    useJobCatalogGenderData(people, isLevel)
  return (
    <Box flexDirection={'row'} gap="s24">
      <JobCatalogGenderChart
        data={data}
        keys={keys}
        count={count}
        malePercentage={malePercentage}
        femalePercentage={femalePercentage}
        notDeclaredPercentage={notDeclaredPercentage}
        groupedBy={groupedBy}
      />
    </Box>
  )
}
